import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon, ArrowRightIcon } from 'lucide-react';
import { adjacentSections, sectionByPath } from '../data/sections';
type PageShellProps = {
  path: string;
  children: React.ReactNode;
};
export function PageShell({
  path,
  children
}: PageShellProps) {
  const section = sectionByPath(path);
  const {
    previous,
    next
  } = adjacentSections(path);
  if (!section) return null;
  return <div className="bg-white" data-id="element-29" data-mp="2ifurv3i780">
      <header className="border-b border-white/10 bg-navy-900 pb-14 pt-28 lg:pb-16 lg:pt-36" data-id="element-30" data-mp="4q8yj6pn7u">
        <div className="mx-auto w-full max-w-7xl px-6 lg:px-10" data-id="element-31" data-mp="4ypquz2cm8wt">
          <p className="font-sans text-xs font-semibold uppercase tracking-[0.24em] text-gold-400" data-id="element-32" data-mp="3m8nrzfl7zzky">
            Section {section.number}
          </p>
          <h1 className="mt-4 max-w-4xl font-display text-4xl font-extrabold leading-[1.05] tracking-tightest text-white sm:text-5xl" data-id="element-33" data-mp="2aua8so1ew8b9">
            {section.name}
          </h1>
          <p className="mt-5 max-w-2xl border-l-2 border-gold-500 pl-5 font-sans text-base leading-relaxed text-platinum-300 lg:text-lg" data-id="element-34" data-mp="2fqqvddsyqem8">
            {section.summary}
          </p>
          <ul className="mt-8 flex flex-wrap gap-2" data-id="element-35" data-mp="8e014qe96gua">
            {section.contains.map(item => <li key={item} className="whitespace-nowrap border border-white/15 px-3 py-1.5 font-sans text-xs font-semibold text-platinum-200" data-id="element-36" data-mp="md83tt9mk738">
                {item}
              </li>)}
          </ul>
        </div>
      </header>

      <main data-id="element-37" data-mp="rahz3pjp3cyz">{children}</main>

      <nav aria-label="Section navigation" className="border-t border-platinum-200 bg-platinum-100" data-id="element-38" data-mp="r96ujnife16t">
        <div className="mx-auto grid w-full max-w-7xl grid-cols-1 gap-px bg-platinum-200 sm:grid-cols-2" data-id="element-39" data-mp="110b1bzxy6fqk">
          {previous ? <Link to={previous.path} className="group flex items-center gap-4 bg-platinum-100 px-6 py-8 transition-colors duration-150 ease-out hover:bg-white lg:px-10" data-id="element-40" data-mp="1f1dlg75dtfyu">
              <ArrowLeftIcon className="h-5 w-5 shrink-0 text-gold-600 transition-transform duration-200 ease-smooth group-hover:-translate-x-1" aria-hidden="true" data-id="element-41" data-mp="7pxt98z7rsfo" />
              <span className="min-w-0" data-id="element-42" data-mp="gmondfu7gx7m">
                <span className="block font-sans text-xs font-semibold uppercase tracking-[0.16em] text-charcoal-600" data-id="element-43" data-mp="lg1blouz31zu">
                  Previous · Section {previous.number}
                </span>
                <span className="mt-1 block font-display text-base font-bold text-navy-900" data-id="element-44" data-mp="vd5wlld30rf2">
                  {previous.name}
                </span>
              </span>
            </Link> : <span className="hidden bg-platinum-100 sm:block" data-id="element-45" data-mp="14elxn2i0bh6m" />}

          {next ? <Link to={next.path} className="group flex items-center justify-end gap-4 bg-platinum-100 px-6 py-8 text-right transition-colors duration-150 ease-out hover:bg-white lg:px-10" data-id="element-46" data-mp="3175pg08lo031">
              <span className="min-w-0" data-id="element-47" data-mp="2ynsgjw9l1aos">
                <span className="block font-sans text-xs font-semibold uppercase tracking-[0.16em] text-charcoal-600" data-id="element-48" data-mp="2tvhiz02be0ze">
                  Next · Section {next.number}
                </span>
                <span className="mt-1 block font-display text-base font-bold text-navy-900" data-id="element-49" data-mp="2ou1u0wx0nabq">
                  {next.name}
                </span>
              </span>
              <ArrowRightIcon className="h-5 w-5 shrink-0 text-gold-600 transition-transform duration-200 ease-smooth group-hover:translate-x-1" aria-hidden="true" data-id="element-50" data-mp="3hkjvxum075nk" />
            </Link> : <span className="hidden bg-platinum-100 sm:block" data-id="element-51" data-mp="33laphmnlnpws" />}
        </div>
      </nav>
    </div>;
}